import { isNil, isEqual } from './nodash';

const isBlank = (string) => {
  return isNil(string) || isEqual('', string);
};

export default isBlank;
